export var menuGroupCSS = function menuGroupCSS(_ref) {
  var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight;
  return {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    maxWidth: maxWidth,
    minWidth: minWidth,
    maxHeight: maxHeight,
    minHeight: minHeight
  };
};